var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found-container"},[_c('card-component',{staticClass:"card",attrs:{"styles":_vm.cardData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }